import React from 'react';
import BookingCancellations from './BookingCancellations';

const BookingCancellationsRoute = () => {
  return <BookingCancellations />;
};

export default BookingCancellationsRoute;